import { UIColors } from '@wolfejs/ui/types/UI';

export const getBadgeColorByStatus = (value: string) => {
  switch (value) {
    case 'Released':
    case 'Pending':
      return UIColors.warning;
    case 'Completed':
    case 'Sent':
    case 'Fulfilled':
      return UIColors.success;
    case 'Canceled':
    case 'Failed':
      return UIColors.error;
    case 'Refunded':
      return UIColors.info;
    case 'Physical':
      return UIColors.secondary;
    case 'Digital':
    default:
      return UIColors.primary;
  }
};
